import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import EnquiryModal from '../components/EnquiryModal';

const EnquiryContext = createContext({ openEnquiry: () => {} });

export const useEnquiry = () => useContext(EnquiryContext);

export function EnquiryProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState('Flight');
  const [prefill, setPrefill] = useState({});

  const openEnquiry = useCallback((cat = 'Flight', data = {}) => {
    setCategory(cat);
    setPrefill(data || {});
    setOpen(true);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  const value = useMemo(() => ({ openEnquiry }), [openEnquiry]);

  return (
    <EnquiryContext.Provider value={value}>
      {children}
      <EnquiryModal open={open} initialCategory={category} initialForm={prefill} onClose={close} />
    </EnquiryContext.Provider>
  );
}
